export default __webpack_public_path__ + "static/media/book_int_highlight.433f78d7.mp3";